"use client";

import { createContext } from "react";
import { type RoomDetailData, type RoomVisitorDetailData } from "~/app/types";

export type CurrentRoom =
  | (RoomDetailData & {
      roomVisitor?: RoomVisitorDetailData["roomVisitor"];
      currentStage: string;
      isPreview?: boolean;
      isEmbedded?: boolean;
      forceFullLayout?: boolean;
    })
  | null;

export const RoomContext = createContext<CurrentRoom>(null);

export const RoomContextProvider = ({ children, room }: { room: CurrentRoom; children: React.ReactNode }) => {
  return <RoomContext.Provider value={room}>{children}</RoomContext.Provider>;
};
